import { isNull } from 'lodash/fp';
import React, { useCallback, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { ConfirmationModal } from '../../shared/modal/ConfirmationModal';
import { downloadPortfolioAnalyticsStarted, getDownloadFilename, setFileName, toggleDownloadModal } from './store';
import { Text } from '../../shared/text/Text';
import styles from './PortfolioAnalytics.module.scss';
import { ModalHeader } from '../../shared/modal/ModalHeader';
import { SaveFile } from '../../shared/icons';

export const PortfolioAnalyticsDownloadModal: React.FC = () => {
    const dispatch = useAppDispatch();
    const fileName = useAppSelector(getDownloadFilename);
    const isOpen = useMemo(() => !isNull(fileName), [fileName]);
    const closeModal = () => dispatch(toggleDownloadModal(null));
    const updateFileName = useCallback((value: string) => dispatch(setFileName(value)), [dispatch]);
    const confirm = useCallback(() => dispatch(downloadPortfolioAnalyticsStarted()), [dispatch]);
    const confirmDisabled = useMemo(() => isNull(fileName) || fileName === '', [fileName]);

    return (
        <ConfirmationModal
            isOpen={isOpen}
            closeModal={closeModal}
            confirm={confirm}
            confirmDisabled={confirmDisabled}
            closeOnOverlayClick={false}
            spaceBetweenButtons
        >
            <div className={styles.downloadModal}>
                <ModalHeader
                    label='Please create a filename for the excel download'
                    testId='portfolio-analytics-download-modal'
                    marginBottom='0px'
                    icon={SaveFile}
                />
                <div className={styles.filenameInput}>
                    <Text
                        onChange={e => updateFileName(e.currentTarget.value)}
                        value={fileName || ''}
                        testId='portfolio-analytics-download'
                        placeholder='File Name...'
                        marginBottom='0px'
                    />
                </div>
            </div>
        </ ConfirmationModal>
    );
};
